import {Constructor} from "../../../../global/constructor";
import {Hash} from "~/interfaces/hashInterfaces";
import {SetDataVariableMap} from "~/models/processFlows/steps/setDataVariableMap";
import {SaveDataVariableMap} from "~/models/processFlows/steps/saveDataVariableMap";
import ProcessFlowStep from "~/models/processFlows/processFlowStep";
import ElementHandler from "~/services/elementHandler";
import {ObjectHelper} from "~/helpers/objectHelper";

export default function MappableStep<TBase extends Constructor<ProcessFlowStep>, TMap extends Constructor<SetDataVariableMap | SaveDataVariableMap>>(Base: TBase, variableMapClass: TMap) {
  return class extends Base {
    variable_maps: Hash<SetDataVariableMap> = {};

    _mapsHandler: ElementHandler<SetDataVariableMap> = new ElementHandler<SetDataVariableMap>(this, SetDataVariableMap, 'variable_maps')
    get variableMapsHandler(): ElementHandler<SetDataVariableMap> {
      return this._mapsHandler
    }

    get variableMapsArray(): Array<SetDataVariableMap> {
      return ObjectHelper.toArray(this.variable_maps).sort((a, b) => a.sort_order - b.sort_order);
    }

    get sortedVariableMaps() {
      return Object.values(this.variable_maps).sort((a, b) => {
        return a.sort_order - b.sort_order
      })
    }

    createVariableMap(json: Hash = {}): SetDataVariableMap | SaveDataVariableMap {
      const variableMap = new variableMapClass(this, {firstCreation: true}).loadFromJson(Object.assign({sort_order: this.variableMapsHandler.nextSortOrder()}, json));
      variableMap.attachToParent(this)
      return variableMap;
    }
  }
}